import { DELIVERY_FREE_TEXT_SORT_NO } from '@/constants'

export default {
  computed: {
    deliveryNotes() {
      return this.$store.state.master.deliveryNote
        .filter((item) => item.sort_no !== DELIVERY_FREE_TEXT_SORT_NO)
        .map((delivery) => ({
          label: delivery.display_name,
          value: delivery.id,
        }))
    },
    deliveryFreeTextId() {
      return this.$store.state.master.deliveryNote.find((i) => i.sort_no === DELIVERY_FREE_TEXT_SORT_NO)?.id
    },
  },
}
